module.exports = __webpack_public_path__ + "img/product_73.f67cf6d.webp";